import Login from "../../components/Login";

export default function LoginPage() {
  return(
    <Login/>
  )
}